import { Jurisdiction, ProductType } from "@obg/ngx.core";

import { GeoFencingErrorType } from "./geofencing.model";

export const GEOFENCING_ERROR = {
	ServerError: "ServerError",
	PermissionDenied: "PermissionDenied",
	PositionUnavailable: "PositionUnavailable",
	PositionTimeout: "PositionTimeout",
	InvalidPosition: "InvalidPosition",
	InvalidArgentinePosition: "InvalidArgentinePosition",
	VpnOrProxyDetected: "VpnOrProxyDetected",
	GeofencingDisabled: "GeofencingDisabled",
	InvalidCountryAccess: "InvalidCountryAccess",
	RadarGeofencingGeneralError: "RadarGeofencingGeneralError",
	RadarGeofencingErrorMultipleTries: "RadarGeofencingErrorMultipleTries",
	RadarGeofencingServerError: "RadarGeofencingServerError",
} as const;

export const POSITION_ERROR_MAP: Record<number, GeoFencingErrorType> = {
	1: GEOFENCING_ERROR.PermissionDenied,
	2: GEOFENCING_ERROR.PositionUnavailable,
	3: GEOFENCING_ERROR.PositionTimeout,
};

export const ARGENTINA_JURISDICTIONS = [Jurisdiction.Lotba, Jurisdiction.Iplyc, Jurisdiction.LPCSE];

export const ONTARIO_BLOCKED_ROUTES = [
	ProductType.LiveCasino,
	ProductType.Poker,
	ProductType.Sportsbook,
	ProductType.VirtualSports,
	"horse-racing",
	"casino.game-launcher",
];

export const ALLOWED_ARGENTINIAN_LOCATION_IDS = ["Buenos Aires Autonomous City", "Buenos Aires", "Cordoba"];

export const ARGENTINA_COUNTRY_CODE = "AR";

export const ALLOWED_ARGENTINIAN_IP_ADMINISTRATIVE_AREA_CODES = ["Buenos Aires", "Cordoba", "Buenos Aires F.D."];

export const MAP_RADAR_GEO_FRAUD_ERROR: Record<string, GeoFencingErrorType> = {
	country_not_allowed: GEOFENCING_ERROR.InvalidCountryAccess,
};
